import React from "react";
import notFound from "assets/images/notFound.png";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const ReportsNotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const renderText = () => {
    if (location.pathname === "/reports/inprogress") {
      return t("notFoundReportsInProgress");
    }
    if (location.pathname === "/reports/followup")
      return t("notFoundReportsToFollow");
    return t("notFoundSearch");
  };
  return (
    <div className="notFoundContainer">
      <img src={notFound} alt="Logo" />
      <div>{renderText()}</div>
    </div>
  );
};

export default ReportsNotFound;
